import { Dispatch, FC, SetStateAction } from "react";
import UnAuthHeaderVersion from "./UnAuthHeaderVersion";
import AuthHeaderVersion from "./AuthHeaderVersion";
import { useSelector } from "react-redux";
import { selectUser } from "../../slices/user-slice";

interface HeaderProps {
    setBackgroundBlur: Dispatch<SetStateAction<boolean>>;
    backgroundBlur: boolean;
}

const Header: FC<HeaderProps> = (props) => {
    const user = useSelector(selectUser());

    return (
        <>
            {user?.id ? (
                <AuthHeaderVersion backgroundBlur={props.backgroundBlur} setBackgroundBlur={props.setBackgroundBlur} />
            ) : (
                <UnAuthHeaderVersion
                    backgroundBlur={props.backgroundBlur}
                    setBackgroundBlur={props.setBackgroundBlur}
                />
            )}
        </>
    );
};

export default Header;
